import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { sendOTP, acceptTerms } from '../services/api';

const SignupMobile = ({
  formData,
  handleChange,
  error,
  handleSignUp,
  collegeType,
  setCollegeType,
  collegeValue,
  setCollegeValue,
  loading,
  isFormValid,
  collegeOptions,
  applicationType,
  setApplicationType,
  registrationType,
  onRegistrationTypeChange,
  orgList,
  orgListLoading,
  selectedExistingOrg,
  setSelectedExistingOrg,
  showOTPStep,
  setShowOTPStep,
  otpCode,
  setOtpCode,
  otpLoading,
  setOtpLoading,
  otpError,
  setOtpError,
  handleVerifyAndRegister,
  agreedToTerms,
  setAgreedToTerms,
  showTermsModal,
  setShowTermsModal,
  termsError,
  setTermsError,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4 relative"
      style={{
        backgroundColor: "#054334",
        backgroundImage: "linear-gradient(to bottom, #004030 10%, rgba(0, 64, 38, 0) 60%), url(assets/login_image.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      <div className="w-full max-w-[400px] bg-white rounded-[32px] shadow-2xl p-6 relative z-10 my-4 flex flex-col">
        {/* Logo */}
        <div className="w-full flex justify-center items-center space-x-2 mb-6 mt-2">
          <img src="assets/osas-logo.png" alt="OrgPass" className="w-5 h-5" onError={(e) => { e.target.style.display = 'none'; }} />
          <span className="font-bold text-gray-800 text-[14px]">OrgPass</span>
        </div>

        {/* Error message */}
        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-xl text-red-600 text-[12px] font-medium text-center">
            {error}
          </div>
        )}

        {/* ── STEP 1: Application Type Selection ── */}
        {applicationType === null ? (
          <div className="w-full flex flex-col items-center">
            <h1 className="text-[24px] font-extrabold text-gray-900 mb-6 text-center">Create your account</h1>

            <p className="text-[12px] font-bold text-gray-800 mb-4 text-center">
              What type of access are you applying for?
            </p>

            <div className="w-full flex flex-col gap-3">
              <button
                type="button"
                onClick={() => setApplicationType('accreditation')}
                className="w-full py-3.5 px-4 rounded-xl border border-gray-200 bg-white text-gray-700 font-bold text-[13px] hover:border-[#086C53] hover:text-[#086C53] hover:bg-[#086C53]/5 transition-all shadow-sm flex items-center justify-center cursor-pointer"
              >
                Accreditation/Re-accreditation
              </button>

              <button
                type="button"
                onClick={() => setApplicationType('offcampus')}
                className="w-full py-3.5 px-4 rounded-xl border border-gray-200 bg-white text-gray-700 font-bold text-[13px] hover:border-[#086C53] hover:text-[#086C53] hover:bg-[#086C53]/5 transition-all shadow-sm flex items-center justify-center cursor-pointer"
              >
                Off-Campus Activity
              </button>
            </div>

            <div className="mt-8 text-center space-y-2">
              <div>
                <span className="text-[11px] text-gray-500 font-medium">Already have an account? </span>
                <Link to="/login" className="text-[#086C53] font-bold text-[11px] hover:underline transition-colors">
                  Login
                </Link>
              </div>
              <div>
                <Link
                  to="/request-status"
                  className="text-[11px] text-gray-400 hover:text-[#086C53] font-medium transition-colors inline-block"
                >
                  Already applied? Check status →
                </Link>
              </div>
            </div>
          </div>
        ) : applicationType === 'offcampus' ? (
          /* ── STEP 2A: Off-Campus Form ── */
          <form onSubmit={handleSignUp} className="space-y-5">
            <div className="text-center mb-4">
              <h1 className="text-[24px] font-extrabold text-gray-900 mb-1 text-center">Create your account</h1>
              <p className="text-[11px] text-gray-500 text-center">Fill the necessary fields</p>
            </div>

            <div className="relative flex items-center justify-center mb-2">
              <button
                type="button"
                onClick={() => setApplicationType(null)}
                className="absolute left-0 text-[11px] font-bold text-gray-400 hover:text-[#086C53] flex items-center gap-1 transition-colors"
              >
                <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M15 19l-7-7 7-7" />
                </svg>
                <span>Back</span>
              </button>
              <span className="text-[12px] font-bold text-gray-700">Off-Campus Activity</span>
            </div>

            <div className="space-y-4">
              <h3 className="font-bold text-[#1a2f4c] text-[13px] mb-2 border-b border-gray-50 pb-2">Personal Information</h3>

              <div>
                <label className="block text-[11px] font-bold text-[#1a2f4c] mb-1">Full Name</label>
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  className="w-full bg-[#f8fafc] border border-gray-100 rounded-xl px-4 py-2.5 text-[12px] text-gray-800 focus:outline-none focus:border-[#086C53] transition"
                  required
                />
              </div>

              <div>
                <label className="block text-[11px] font-bold text-[#1a2f4c] mb-1">Email</label>
                <input
                  type="email"
                  name="email"
                  placeholder="@slsu.edu.ph or @gmail.com"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full bg-[#f8fafc] border border-gray-100 rounded-xl px-4 py-2.5 text-[12px] text-gray-800 focus:outline-none focus:border-[#086C53] transition"
                  required
                />
                <p className="text-[10px] text-gray-500 mt-1">
                  <span className="font-semibold text-gray-600">Note:</span> Satellite campuses may use @gmail.com if @slsu.edu.ph is unavailable.
                </p>
              </div>

              <div className="relative">
                <label className="block text-[11px] font-bold text-[#1a2f4c] mb-1">Password</label>
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className="w-full bg-[#f8fafc] border border-gray-100 rounded-xl px-4 py-2.5 text-[12px] text-gray-800 focus:outline-none focus:border-[#086C53] transition"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-[26px] text-gray-400 hover:text-[#086C53]"
                >
                  {showPassword ? (
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
                  ) : (
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" /></svg>
                  )}
                </button>
              </div>

              <div className="relative">
                <label className="block text-[11px] font-bold text-[#1a2f4c] mb-1">Confirm Password</label>
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  className="w-full bg-[#f8fafc] border border-gray-100 rounded-xl px-4 py-2.5 text-[12px] text-gray-800 focus:outline-none focus:border-[#086C53] transition"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  className="absolute right-3 top-[26px] text-gray-400 hover:text-[#086C53]"
                >
                  {showConfirmPassword ? (
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
                  ) : (
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" /></svg>
                  )}
                </button>
              </div>
            </div>

            <div className="space-y-4">
              <h3 className="font-bold text-[#1a2f4c] text-[13px] mb-2 border-b border-gray-50 pb-2 mt-4">
                Activity Information
              </h3>

              <div>
                <label className="block text-[11px] font-bold text-[#1a2f4c] mb-1">Activity Name</label>
                <input
                  type="text"
                  name="activityName"
                  value={formData.activityName}
                  onChange={handleChange}
                  className="w-full bg-[#f8fafc] border border-gray-100 rounded-xl px-4 py-2.5 text-[12px] text-gray-800 focus:outline-none focus:border-[#086C53] transition"
                  required
                />
              </div>

              <div>
                <label className="block text-[11px] font-bold text-[#1a2f4c] mb-1">College/Campus</label>
                <div className="flex gap-2">
                  <select
                    value={collegeType}
                    onChange={(e) => { setCollegeType(e.target.value); setCollegeValue(''); }}
                    className="flex-1 bg-white border border-gray-200 rounded-xl px-2 py-2.5 text-[12px] text-gray-800 focus:outline-none focus:border-[#086C53] transition"
                  >
                    <option value="">College/Campus</option>
                    <option value="College">College</option>
                    <option value="Campus">Campus</option>
                  </select>
                  <select
                    value={collegeValue}
                    onChange={(e) => setCollegeValue(e.target.value)}
                    disabled={!collegeType}
                    className="flex-1 bg-white border border-gray-200 rounded-xl px-2 py-2.5 text-[12px] text-gray-800 focus:outline-none focus:border-[#086C53] transition disabled:bg-gray-50 disabled:text-gray-400"
                  >
                    <option value="">{collegeType ? `Select ${collegeType}` : 'Select first'}</option>
                    {collegeType &&
                      collegeOptions[collegeType].map((c) => (
                        <option key={c} value={c}>{c}</option>
                      ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="flex items-start space-x-3 mt-2">
              <input
                type="checkbox"
                id="terms-checkbox-mobile"
                checked={agreedToTerms}
                onChange={(e) => {
                  setAgreedToTerms(e.target.checked);
                  if (e.target.checked) setTermsError('');
                }}
                className="mt-1 w-4 h-4 accent-[#086C53] cursor-pointer flex-shrink-0"
              />
              <label htmlFor="terms-checkbox-mobile" className="text-[13px] text-gray-600 leading-relaxed">
                I have read and agree to the{' '}
                <button
                  type="button"
                  onClick={() => setShowTermsModal(true)}
                  className="text-[#086C53] font-bold underline hover:text-[#054334] transition-colors"
                >
                  Terms and Conditions
                </button>
                {' '}and{' '}
                <button
                  type="button"
                  onClick={() => setShowTermsModal(true)}
                  className="text-[#086C53] font-bold underline hover:text-[#054334] transition-colors"
                >
                  Privacy Policy
                </button>
                {' '}of OrgPass.
              </label>
            </div>
            {termsError && (
              <p className="text-red-500 text-[12px] font-medium mt-1">{termsError}</p>
            )}

            <div className="pt-2">
              <button
                type="submit"
                disabled={loading || !isFormValid}
                className="w-full bg-[#054334] text-white font-bold text-[13px] py-4 rounded-xl flex justify-center items-center space-x-2 transition disabled:opacity-60 disabled:cursor-not-allowed hover:bg-[#065c47]"
              >
                <span>{loading ? "Submitting..." : "Request Access"}</span>
                {!loading && (
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                )}
              </button>
              <div className="mt-4 text-center space-y-2">
                <div>
                  <span className="text-[11px] text-gray-500 font-medium">Already have an account? </span>
                  <Link to="/login" className="text-[#086C53] font-bold text-[11px] hover:underline transition-colors">
                    Login
                  </Link>
                </div>
                <div>
                  <Link
                    to="/request-status"
                    className="text-[11px] text-gray-400 hover:text-[#086C53] font-medium transition-colors inline-block"
                  >
                    Already applied? Check status →
                  </Link>
                </div>
              </div>
            </div>
          </form>
        ) : (
          /* ── STEP 2B: Accreditation / Re-accreditation Form ── */
          <form onSubmit={handleSignUp} className="space-y-6">
            <div className="text-center mb-4">
              <h1 className="text-[24px] font-extrabold text-gray-900 mb-1 text-center">Create your account</h1>
              <p className="text-[11px] text-gray-500 text-center">Fill the necessary fields</p>
            </div>

            <div className="flex items-center justify-between mb-1">
              <button
                type="button"
                onClick={() => setApplicationType(null)}
                className="text-[11px] font-bold text-gray-400 hover:text-[#086C53] flex items-center gap-1 transition-colors"
              >
                <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M15 19l-7-7 7-7" />
                </svg>
                <span>Change access type</span>
              </button>
            </div>

            {/* Registration Type Selection */}
            <div>
              <label className="block text-[11px] font-bold text-gray-800 mb-2 text-center">What access type are you applying for?</label>
              <div className="flex gap-2 justify-center">
                {/* Existing Org (Handover) */}
                <div
                  className={`flex-1 flex items-center justify-center space-x-1.5 px-2 py-2.5 rounded-xl border-2 cursor-pointer transition-all ${registrationType === 'existing'
                      ? 'border-[#086C53] bg-[#086C53]/5 text-[#086C53]'
                      : 'border-gray-200 bg-gray-50 text-gray-500'
                    }`}
                  onClick={() => onRegistrationTypeChange('existing')}
                >
                  <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                  </svg>
                  <span className="text-[10px] font-bold leading-tight text-center">Existing Org<br />(Handover)</span>
                </div>

                {/* New Organization */}
                <div
                  className={`flex-1 flex items-center justify-center space-x-1.5 px-2 py-2.5 rounded-xl border-2 cursor-pointer transition-all ${registrationType === 'new'
                      ? 'border-[#086C53] bg-[#086C53]/5 text-[#086C53]'
                      : 'border-gray-200 bg-gray-50 text-gray-500'
                    }`}
                  onClick={() => onRegistrationTypeChange('new')}
                >
                  <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                  </svg>
                  <span className="text-[10px] font-bold leading-tight text-center">New<br />Organization</span>
                </div>
              </div>
              <p className="text-[10px] text-gray-400 text-center mt-2">
                {registrationType === 'existing'
                  ? 'Re-accreditation — 15 document requirements'
                  : 'Accreditation — 12 document requirements'}
              </p>
            </div>

            <div className="space-y-4">
              {/* Personal Information */}
              <h3 className="font-bold text-[#1a2f4c] text-[14px] mb-2 border-b border-gray-50 pb-2">Personal Information</h3>

              <div>
                <label className="block text-[11px] font-bold text-[#1a2f4c] mb-1">Full Name</label>
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  className="w-full bg-[#f8fafc] border border-gray-100 rounded-xl px-4 py-2.5 text-[12px] text-gray-800 focus:outline-none focus:border-[#086C53] transition"
                  required
                />
              </div>
              <div>
                <label className="block text-[11px] font-bold text-[#1a2f4c] mb-1">Email</label>
                <input
                  type="email"
                  name="email"
                  placeholder="@slsu.edu.ph or @gmail.com"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full bg-[#f8fafc] border border-gray-100 rounded-xl px-4 py-2.5 text-[12px] text-gray-800 focus:outline-none focus:border-[#086C53] transition"
                  required
                />
                <p className="text-[10px] text-gray-500 mt-1">
                  <span className="font-semibold text-gray-600">Note:</span> Satellite campuses may use @gmail.com if @slsu.edu.ph is unavailable.
                </p>
              </div>
              <div className="relative">
                <label className="block text-[11px] font-bold text-[#1a2f4c] mb-1">Password</label>
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className="w-full bg-[#f8fafc] border border-gray-100 rounded-xl px-4 py-2.5 text-[12px] text-gray-800 focus:outline-none focus:border-[#086C53] transition"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-[26px] text-gray-400 hover:text-[#086C53]"
                >
                  {showPassword ? (
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
                  ) : (
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" /></svg>
                  )}
                </button>
              </div>
              <div className="relative">
                <label className="block text-[11px] font-bold text-[#1a2f4c] mb-1">Confirm Password</label>
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  className="w-full bg-[#f8fafc] border border-gray-100 rounded-xl px-4 py-2.5 text-[12px] text-gray-800 focus:outline-none focus:border-[#086C53] transition"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  className="absolute right-3 top-[26px] text-gray-400 hover:text-[#086C53]"
                >
                  {showConfirmPassword ? (
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
                  ) : (
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" /></svg>
                  )}
                </button>
              </div>
            </div>

            <div className="space-y-4">
              {/* Organization Information */}
              <h3 className="font-bold text-[#1a2f4c] text-[14px] mb-2 border-b border-gray-50 pb-2 mt-4">
                Organization Information
              </h3>

              {registrationType === 'existing' ? (
                /* ── Existing Org (Handover) ── */
                <>
                  <div>
                    <label className="block text-[11px] font-bold text-[#1a2f4c] mb-1">Select Your Organization</label>
                    {orgListLoading ? (
                      <div className="w-full bg-[#f8fafc] border border-gray-100 rounded-xl px-4 py-2.5 text-[12px] text-gray-400">
                        Loading...
                      </div>
                    ) : (
                      <select
                        value={selectedExistingOrg ? selectedExistingOrg.organization_id : ''}
                        onChange={(e) => {
                          const org = orgList.find(o => o.organization_id === parseInt(e.target.value));
                          setSelectedExistingOrg(org || null);
                        }}
                        className="w-full bg-[#f8fafc] border border-gray-100 rounded-xl px-4 py-2.5 text-[12px] text-gray-800 focus:outline-none focus:border-[#086C53] transition"
                        required
                      >
                        <option value="">— Select an organization —</option>
                        {orgList.map(org => (
                          <option key={org.organization_id} value={org.organization_id}>
                            {org.name}{org.acronym ? ` (${org.acronym})` : ''}
                          </option>
                        ))}
                      </select>
                    )}
                    {orgList.length === 0 && !orgListLoading && (
                      <p className="text-[10px] text-gray-400 mt-1">No existing organizations found.</p>
                    )}
                  </div>

                  {selectedExistingOrg && (
                    <div className="bg-[#f0fdf4] border border-[#bbf7d0] rounded-xl px-3 py-2">
                      <p className="text-[11px] font-bold text-[#166534]">{selectedExistingOrg.name}</p>
                      {selectedExistingOrg.college && (
                        <p className="text-[10px] text-[#15803d]">{selectedExistingOrg.college}</p>
                      )}
                      <p className="text-[10px] text-[#15803d] font-medium mt-0.5">✓ Re-accreditation (15 docs)</p>
                    </div>
                  )}

                  <div>
                    <label className="block text-[11px] font-bold text-[#1a2f4c] mb-1">Position</label>
                    <input
                      type="text"
                      name="position"
                      value={formData.position || 'President'}
                      readOnly
                      className="w-full bg-[#f1f5f9] border border-gray-100 rounded-xl px-4 py-2.5 text-[12px] text-gray-700 font-medium cursor-not-allowed select-none focus:outline-none"
                    />
                  </div>

                  <div>
                    <label className="block text-[11px] font-bold text-[#1a2f4c] mb-1">President Contact Number</label>
                    <input
                      type="tel"
                      name="presidentContact"
                      placeholder="e.g. 09123456789"
                      value={formData.presidentContact}
                      onChange={handleChange}
                      className="w-full bg-[#f8fafc] border border-gray-100 rounded-xl px-4 py-2.5 text-[12px] text-gray-800 focus:outline-none focus:border-[#086C53] transition"
                    />
                  </div>

                  <div>
                    <label className="block text-[11px] font-bold text-[#1a2f4c] mb-1">Adviser Name</label>
                    <input
                      type="text"
                      name="adviserName"
                      placeholder="e.g. Prof. Juan Dela Cruz"
                      value={formData.adviserName}
                      onChange={handleChange}
                      className="w-full bg-[#f8fafc] border border-gray-100 rounded-xl px-4 py-2.5 text-[12px] text-gray-800 focus:outline-none focus:border-[#086C53] transition"
                    />
                  </div>

                  <div>
                    <label className="block text-[11px] font-bold text-[#1a2f4c] mb-1">Adviser Contact Number</label>
                    <input
                      type="tel"
                      name="adviserContact"
                      placeholder="e.g. 09123456789"
                      value={formData.adviserContact}
                      onChange={handleChange}
                      className="w-full bg-[#f8fafc] border border-gray-100 rounded-xl px-4 py-2.5 text-[12px] text-gray-800 focus:outline-none focus:border-[#086C53] transition"
                    />
                  </div>

                  <div>
                    <label className="block text-[11px] font-bold text-[#1a2f4c] mb-1">Total Number of Members</label>
                    <input
                      type="number"
                      name="totalMembers"
                      placeholder="e.g. 50"
                      min="1"
                      value={formData.totalMembers}
                      onChange={handleChange}
                      className="w-full bg-[#f8fafc] border border-gray-100 rounded-xl px-4 py-2.5 text-[12px] text-gray-800 focus:outline-none focus:border-[#086C53] transition"
                    />
                  </div>
                </>
              ) : (
                /* ── New Organization ── */
                <>
                  <div>
                    <label className="block text-[11px] font-bold text-[#1a2f4c] mb-1">Organization Name</label>
                    <input
                      type="text"
                      name="orgName"
                      value={formData.orgName}
                      onChange={handleChange}
                      className="w-full bg-[#f8fafc] border border-gray-100 rounded-xl px-4 py-2.5 text-[12px] text-gray-800 focus:outline-none focus:border-[#086C53] transition"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-[11px] font-bold text-[#1a2f4c] mb-1">Acronym (if any)</label>
                    <input
                      type="text"
                      name="acronym"
                      value={formData.acronym}
                      onChange={handleChange}
                      className="w-full bg-[#f8fafc] border border-gray-100 rounded-xl px-4 py-2.5 text-[12px] text-gray-800 focus:outline-none focus:border-[#086C53] transition"
                    />
                  </div>
                  <div>
                    <label className="block text-[11px] font-bold text-[#1a2f4c] mb-1">Type of Student Organization</label>
                    <select
                      name="orgCategory"
                      value={formData.orgCategory}
                      onChange={handleChange}
                      className="w-full bg-[#f8fafc] border border-gray-100 rounded-xl px-4 py-2.5 text-[12px] text-gray-800 focus:outline-none focus:border-[#086C53] transition cursor-pointer"
                    >
                      <option value="">— Select Type of Organization —</option>
                      <option value="Academic">Academic</option>
                      <option value="Civic">Civic (Non-Academic)</option>
                      <option value="Cultural">Cultural</option>
                      <option value="Religious">Religious</option>
                      <option value="Socio-Political">Socio-Political</option>
                      <option value="Sports">Sports</option>
                      <option value="Student Council">Student Council</option>
                      <option value="Others">Others</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-[11px] font-bold text-[#1a2f4c] mb-1">College/Campus</label>
                    <div className="flex gap-2">
                      <select
                        value={collegeType}
                        onChange={(e) => { setCollegeType(e.target.value); setCollegeValue(''); }}
                        className="flex-1 bg-white border border-gray-200 rounded-xl px-2 py-2.5 text-[12px] text-gray-800 focus:outline-none focus:border-[#086C53] transition"
                      >
                        <option value="">College/Campus</option>
                        <option value="College">College</option>
                        <option value="Campus">Campus</option>
                      </select>
                      <select
                        value={collegeValue}
                        onChange={(e) => setCollegeValue(e.target.value)}
                        disabled={!collegeType}
                        className="flex-1 bg-white border border-gray-200 rounded-xl px-2 py-2.5 text-[12px] text-gray-800 focus:outline-none focus:border-[#086C53] transition disabled:bg-gray-50 disabled:text-gray-400"
                      >
                        <option value="">{collegeType ? `Select ${collegeType}` : 'Select first'}</option>
                        {collegeType &&
                          collegeOptions[collegeType].map((c) => (
                            <option key={c} value={c}>{c}</option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div>
                    <label className="block text-[11px] font-bold text-[#1a2f4c] mb-1">Position</label>
                    <input
                      type="text"
                      name="position"
                      value={formData.position || 'President'}
                      readOnly
                      className="w-full bg-[#f1f5f9] border border-gray-100 rounded-xl px-4 py-2.5 text-[12px] text-gray-700 font-medium cursor-not-allowed select-none focus:outline-none"
                    />
                  </div>
                  <div>
                    <label className="block text-[11px] font-bold text-[#1a2f4c] mb-1">President Contact Number</label>
                    <input
                      type="tel"
                      name="presidentContact"
                      placeholder="e.g. 09123456789"
                      value={formData.presidentContact}
                      onChange={handleChange}
                      className="w-full bg-[#f8fafc] border border-gray-100 rounded-xl px-4 py-2.5 text-[12px] text-gray-800 focus:outline-none focus:border-[#086C53] transition"
                    />
                  </div>
                  <div>
                    <label className="block text-[11px] font-bold text-[#1a2f4c] mb-1">Adviser Name</label>
                    <input
                      type="text"
                      name="adviserName"
                      placeholder="e.g. Prof. Juan Dela Cruz"
                      value={formData.adviserName}
                      onChange={handleChange}
                      className="w-full bg-[#f8fafc] border border-gray-100 rounded-xl px-4 py-2.5 text-[12px] text-gray-800 focus:outline-none focus:border-[#086C53] transition"
                    />
                  </div>
                  <div>
                    <label className="block text-[11px] font-bold text-[#1a2f4c] mb-1">Adviser Contact Number</label>
                    <input
                      type="tel"
                      name="adviserContact"
                      placeholder="e.g. 09123456789"
                      value={formData.adviserContact}
                      onChange={handleChange}
                      className="w-full bg-[#f8fafc] border border-gray-100 rounded-xl px-4 py-2.5 text-[12px] text-gray-800 focus:outline-none focus:border-[#086C53] transition"
                    />
                  </div>
                  <div>
                    <label className="block text-[11px] font-bold text-[#1a2f4c] mb-1">Total Number of Members</label>
                    <input
                      type="number"
                      name="totalMembers"
                      placeholder="e.g. 50"
                      min="1"
                      value={formData.totalMembers}
                      onChange={handleChange}
                      className="w-full bg-[#f8fafc] border border-gray-100 rounded-xl px-4 py-2.5 text-[12px] text-gray-800 focus:outline-none focus:border-[#086C53] transition"
                    />
                  </div>
                </>
              )}
            </div>

            <div className="flex items-start space-x-3 mt-2">
              <input
                type="checkbox"
                id="terms-checkbox-mobile-accred"
                checked={agreedToTerms}
                onChange={(e) => {
                  setAgreedToTerms(e.target.checked);
                  if (e.target.checked) setTermsError('');
                }}
                className="mt-1 w-4 h-4 accent-[#086C53] cursor-pointer flex-shrink-0"
              />
              <label htmlFor="terms-checkbox-mobile-accred" className="text-[13px] text-gray-600 leading-relaxed">
                I have read and agree to the{' '}
                <button
                  type="button"
                  onClick={() => setShowTermsModal(true)}
                  className="text-[#086C53] font-bold underline hover:text-[#054334] transition-colors"
                >
                  Terms and Conditions
                </button>
                {' '}and{' '}
                <button
                  type="button"
                  onClick={() => setShowTermsModal(true)}
                  className="text-[#086C53] font-bold underline hover:text-[#054334] transition-colors"
                >
                  Privacy Policy
                </button>
                {' '}of OrgPass.
              </label>
            </div>
            {termsError && (
              <p className="text-red-500 text-[12px] font-medium mt-1">{termsError}</p>
            )}

            <div className="pt-2">
              <button
                type="submit"
                disabled={loading || !isFormValid}
                className="w-full bg-[#054334] text-white font-bold text-[13px] py-4 rounded-xl flex justify-center items-center space-x-2 transition disabled:opacity-60 disabled:cursor-not-allowed hover:bg-[#065c47]"
              >
                <span>{loading ? "Submitting..." : "Request Access"}</span>
                {!loading && (
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                )}
              </button>
              <div className="mt-4 text-center space-y-2">
                <div>
                  <span className="text-[11px] text-gray-500 font-medium">Already have an account? </span>
                  <Link to="/login" className="text-[#086C53] font-bold text-[11px] hover:underline transition-colors">
                    Login
                  </Link>
                </div>
                <div>
                  <Link
                    to="/request-status"
                    className="text-[11px] text-gray-400 hover:text-[#086C53] font-medium transition-colors inline-block"
                  >
                    Already applied? Check status →
                  </Link>
                </div>
              </div>
            </div>
          </form>
        )}
      </div>

      {showOTPStep && (
        <div className="fixed inset-0 bg-white/95 backdrop-blur-sm z-50 flex items-center justify-center p-6">
          <div className="w-full max-w-sm flex flex-col items-center">
            <div className="w-16 h-16 rounded-full bg-[#e0f5ee] flex items-center justify-center mb-6">
              <svg className="w-8 h-8 text-[#054334]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <h2 className="text-[22px] font-extrabold text-gray-900 mb-2 text-center">Verify your email</h2>
            <p className="text-[13px] text-gray-500 text-center mb-6">
              We sent a 6-digit code to your email. Enter it below.
            </p>
            {otpError && (
              <div className="w-full mb-4 p-3 bg-red-50 border border-red-200 rounded-xl text-red-600 text-[13px] font-medium text-center">
                {otpError}
              </div>
            )}
            <form onSubmit={handleVerifyAndRegister} className="w-full space-y-4">
              <input
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                autoComplete="one-time-code"
                value={otpCode}
                onChange={(e) => setOtpCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                placeholder="000000"
                maxLength={6}
                className="w-full bg-[#f8fafc] border border-gray-200 rounded-xl px-5 py-4 text-[24px] font-bold text-center text-gray-800 tracking-[0.5em] focus:outline-none focus:ring-2 focus:ring-[#086C53]/30 transition"
                required
                autoFocus
              />
              <button
                type="submit"
                disabled={otpLoading || otpCode.length !== 6}
                className="w-full py-4 rounded-xl text-[15px] font-bold text-white transition-colors shadow-md disabled:opacity-60 cursor-pointer"
                style={{ background: '#054334' }}
              >
                {otpLoading ? 'Verifying...' : 'Verify & Complete Registration'}
              </button>
              <div className="flex flex-col items-center space-y-2">
                <button
                  type="button"
                  onClick={async () => {
                    try {
                      await sendOTP(formData.email, 'registration', applicationType);
                      setOtpError('');
                      setOtpCode('');
                    } catch (err) {
                      setOtpError('Failed to resend code.');
                    }
                  }}
                  className="text-[13px] text-[#086C53] font-semibold hover:underline cursor-pointer"
                >
                  Resend code
                </button>
                <button
                  type="button"
                  onClick={() => { setShowOTPStep(false); setOtpCode(''); setOtpError(''); }}
                  className="text-[13px] text-gray-400 font-medium cursor-pointer"
                >
                  ← Go back and edit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showTermsModal && (
        <div className="fixed inset-0 bg-black/60 z-[9999] flex items-center justify-center p-4 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col">
            <div className="flex justify-between items-center px-6 py-4 border-b border-gray-200">
              <h2 className="text-[20px] font-bold text-gray-900">Terms and Conditions & Privacy Policy</h2>
              <button onClick={() => setShowTermsModal(false)}
                className="text-gray-400 hover:text-gray-600 transition-colors">
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="flex-1 overflow-y-auto px-6 py-4 space-y-6 text-[13px] text-gray-700 leading-relaxed">

              <div>
                <p className="text-[11px] text-gray-400 font-bold uppercase tracking-wider mb-1">OrgPass — SLSU-OSAS</p>
                <p className="text-[11px] text-gray-400">Effective Date: Academic Year 2025-2026</p>
              </div>

              <div>
                <h3 className="font-bold text-gray-900 text-[15px] mb-2">1. Acceptance of Terms</h3>
                <p>By registering and using OrgPass, you agree to these Terms and Conditions. If you do not agree, do not use the system. These terms apply to all users including organization presidents, advisers, and OSAS administrators.</p>
              </div>

              <div>
                <h3 className="font-bold text-gray-900 text-[15px] mb-2">2. Purpose of the System</h3>
                <p>OrgPass is an official document submission and validation system developed for SLSU-OSAS to digitize the student organization accreditation and off-campus activity approval process. It is intended solely for use by registered SLSU student organizations and OSAS staff.</p>
              </div>

              <div>
                <h3 className="font-bold text-gray-900 text-[15px] mb-2">3. User Accounts and Eligibility</h3>
                <ul className="list-disc pl-5 space-y-1">
                  <li>Only users with a valid <strong>@slsu.edu.ph</strong> or <strong>@gmail.com</strong> email address may register</li>
                  <li>Each student organization may only have one registered account</li>
                  <li>Users are responsible for maintaining the confidentiality of their credentials</li>
                  <li>Accounts are non-transferable</li>
                  <li>OSAS reserves the right to suspend or terminate accounts that violate these terms</li>
                </ul>
              </div>

              <div>
                <h3 className="font-bold text-gray-900 text-[15px] mb-2">4. Document Submission</h3>
                <ul className="list-disc pl-5 space-y-1">
                  <li>Users are responsible for the accuracy and authenticity of all submitted documents</li>
                  <li>Submission of falsified, altered, or fraudulent documents is strictly prohibited and may result in account termination and referral to the appropriate SLSU disciplinary committee</li>
                  <li>Submitted documents must comply with OSAS requirements and CMO No. 63 s. 2017 for off-campus activities</li>
                  <li>Documents submitted through OrgPass are official submissions to SLSU-OSAS</li>
                </ul>
              </div>

              <div>
                <h3 className="font-bold text-gray-900 text-[15px] mb-2">5. Artificial Intelligence (AI) Document Validation</h3>
                <ul className="list-disc pl-5 space-y-1">
                  <li>OrgPass uses Google Gemini AI to perform automated document validation</li>
                  <li>AI validation is assistive only — it flags potential issues and provides recommendations</li>
                  <li>Final review and approval decisions are made solely by OSAS administrators, not by the AI system</li>
                  <li>AI validation results may not be 100% accurate and should not be solely relied upon</li>
                  <li>By submitting documents, you consent to their analysis by Google Gemini AI for validation purposes</li>
                  <li>Since OrgPass uses the paid tier of the Google Gemini API, your submitted documents are NOT used to train Google's AI models</li>
                </ul>
              </div>

              <div>
                <h3 className="font-bold text-gray-900 text-[15px] mb-2">6. Data Collection and Use</h3>
                <p className="mb-2">We collect and process the following information:</p>
                <p className="font-semibold mb-1">Personal Information:</p>
                <ul className="list-disc pl-5 space-y-1 mb-2">
                  <li>Full name, email address (@slsu.edu.ph or @gmail.com)</li>
                  <li>Organization name, college/campus</li>
                  <li>Adviser information and contact details</li>
                </ul>
                <p className="font-semibold mb-1">Document Data:</p>
                <ul className="list-disc pl-5 space-y-1 mb-2">
                  <li>Submitted documents (PDF, DOCX, images)</li>
                  <li>Document metadata (submission date, status)</li>
                  <li>AI validation results</li>
                </ul>
                <p>This data is used exclusively for processing accreditation and off-campus activity applications, AI-powered document validation, communication regarding application status, and system administration by OSAS staff.</p>
              </div>

              <div>
                <h3 className="font-bold text-gray-900 text-[15px] mb-2">7. Data Sharing with Third-Party Services</h3>
                <p className="mb-2">Your data may be shared with the following third-party services solely for system operation:</p>
                <ul className="list-disc pl-5 space-y-1">
                  <li><span className="font-semibold">Google Gemini AI</span> — Document validation (document content only)</li>
                  <li><span className="font-semibold">A cloud storage service</span> — Template file storage (template files only)</li>
                  <li><span className="font-semibold">An email delivery service</span> — Email notifications (email address only)</li>
                  <li><span className="font-semibold">A secure cloud server</span> — System hosting (all system data)</li>
                </ul>
                <p className="mt-2 text-[12px] text-gray-500 italic">We do not sell, rent, or share your personal data with any other third parties.</p>
              </div>

              <div>
                <h3 className="font-bold text-gray-900 text-[15px] mb-2">8. Data Storage and Security</h3>
                <ul className="list-disc pl-5 space-y-1">
                  <li>All submitted documents are stored on a secure cloud server</li>
                  <li>Data is transmitted using HTTPS/TLS encryption</li>
                  <li>Passwords are stored as cryptographic hash — never in plain text</li>
                  <li>Access to submitted documents is restricted to the submitting organization and authorized OSAS administrators</li>
                  <li>Authentication is required for all system access</li>
                </ul>
              </div>

              <div>
                <h3 className="font-bold text-gray-900 text-[15px] mb-2">9. Data Retention</h3>
                <ul className="list-disc pl-5 space-y-1">
                  <li>Submitted documents and user accounts are retained for the duration of the academic year</li>
                  <li>At the end of each academic year, accreditation documents and user accounts are deleted as part of the system's academic year reset</li>
                  <li>Organization records are retained for continuity across academic years</li>
                  <li>Off-campus activity documents are retained separately per OSAS policy</li>
                </ul>
              </div>

              <div>
                <h3 className="font-bold text-gray-900 text-[15px] mb-2">10. User Rights</h3>
                <p>As a registered user, you have the right to:</p>
                <ul className="list-disc pl-5 space-y-1">
                  <li>View all documents you have submitted</li>
                  <li>Cancel or delete unreviewed document submissions</li>
                  <li>Request correction of your personal information by contacting OSAS</li>
                  <li>Request deletion of your account by contacting OSAS</li>
                </ul>
              </div>

              <div>
                <h3 className="font-bold text-gray-900 text-[15px] mb-2">11. Prohibited Activities</h3>
                <ul className="list-disc pl-5 space-y-1">
                  <li>Submitting documents on behalf of another organization without authorization</li>
                  <li>Attempting to access other organizations' data</li>
                  <li>Using the system for any purpose other than SLSU-OSAS accreditation processes</li>
                  <li>Attempting to circumvent security measures</li>
                  <li>Uploading malicious files or content</li>
                  <li>Sharing account credentials with unauthorized persons</li>
                </ul>
              </div>

              <div>
                <h3 className="font-bold text-gray-900 text-[15px] mb-2">12. Limitation of Liability</h3>
                <ul className="list-disc pl-5 space-y-1">
                  <li>OrgPass is provided as an official tool of SLSU-OSAS on an "as-is" basis</li>
                  <li>SLSU-OSAS is not liable for any technical issues, data loss, or service interruptions</li>
                  <li>AI validation results are advisory only — SLSU-OSAS is not liable for AI errors or inaccuracies</li>
                  <li>Users are solely responsible for the content and accuracy of submitted documents</li>
                </ul>
              </div>

              <div>
                <h3 className="font-bold text-gray-900 text-[15px] mb-2">13. Contact Information</h3>
                <p>For questions, concerns, or data requests related to OrgPass:</p>
                <p className="mt-2 font-semibold">SLSU Office of Student Affairs and Services (OSAS)</p>
                <p>Southern Luzon State University</p>
                <p>Email: orgpass.slsu@gmail.com</p>
              </div>

            </div>
            <div className="px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
              <button
                onClick={() => setShowTermsModal(false)}
                className="px-5 py-2 border border-gray-300 rounded-lg text-[13px] font-bold text-gray-700 hover:bg-gray-50 transition-colors"
              >
                Close
              </button>
              <button
                onClick={() => {
                  setAgreedToTerms(true);
                  setShowTermsModal(false);
                  setTermsError('');
                }}
                className="px-5 py-2 bg-[#086C53] text-white rounded-lg text-[13px] font-bold hover:bg-[#054334] transition-colors"
              >
                I Agree
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SignupMobile;
